// Small adjustments found by simulation so that no show is over- or under-recommended.
// 'adult' is used for solo, date and friends; 'family' for families. If you change many show profiles, ask for these to be re-fitted.
export const NUDGES = {
    "adult": {
     "ABBA Voyage": -0.12,
     "As You Like It": 0.105,
     "Avenue Q": 0.12,
     "Beetlejuice: The Musical": 0.086,
     "Billy Elliot the Musical": 0.12,
     "Cabaret": 0.029,
     "Christmas Carol Goes Wrong": -0.029,
     "Hadestown": 0.08,
     "Hamilton": 0.092,
     "Hamlet": 0.022,
     "Harry Potter and the Cursed Child": 0.054,
     "Hay Fever": -0.001,
     "Into the Woods": 0.12,
     "Jesus Christ Superstar": -0.12,
     "John Proctor Is the Villain": 0.111,
     "Les Misérables": 0.116,
     "Mamma Mia!": 0.12,
     "Matilda The Musical": 0.119,
     "Moulin Rouge! The Musical": 0.102,
     "Much Ado About Nothing": 0.109,
     "Murder, She Didn't Write": -0.101,
     "My Neighbour Totoro": 0.062,
     "Oh, Mary!": -0.107,
     "Oliver!": 0.061,
     "Operation Mincemeat": 0.108,
     "Paddington The Musical": 0,
     "Pretty Woman The Musical": 0.098,
     "Pride": 0.12,
     "RENT": 0.086,
     "Romeo & Juliet": 0.081,
     "Rosencrantz and Guildenstern Are Dead": 0.06,
     "SIX the Musical": -0.073,
     "Sinatra the Musical": 0.093,
     "Stranger Things: The First Shadow": -0.005,
     "The Book of Mormon": 0.083,
     "The Cherry Orchard": 0.024,
     "The Devil Wears Prada": 0.035,
     "The Hunger Games: On Stage": -0.013,
     "The Jungle Book": 0,
     "The Lion King": 0.104,
     "The Lives of Others": -0.002,
     "The Mousetrap": -0.107,
     "The Phantom of the Opera": 0.053,
     "The Play That Goes Wrong": 0.034,
     "The Standard of Living": -0.12,
     "Titanique": -0.113,
     "Wicked": 0.11
    },
    "family": {
     "ABBA Voyage": -0.055,
     "As You Like It": 0,
     "Avenue Q": 0,
     "Beetlejuice: The Musical": 0.091,
     "Billy Elliot the Musical": 0.074,
     "Cabaret": 0,
     "Christmas Carol Goes Wrong": 0.04,
     "Hadestown": 0,
     "Hamilton": 0.011,
     "Hamlet": 0,
     "Harry Potter and the Cursed Child": 0.039,
     "Hay Fever": 0,
     "Into the Woods": 0.053,
     "Jesus Christ Superstar": 0,
     "John Proctor Is the Villain": 0,
     "Les Misérables": 0.052,
     "Mamma Mia!": -0.062,
     "Matilda The Musical": 0.062,
     "Moulin Rouge! The Musical": 0,
     "Much Ado About Nothing": -0.003,
     "Murder, She Didn't Write": 0,
     "My Neighbour Totoro": 0.076,
     "Oh, Mary!": 0,
     "Oliver!": 0.035,
     "Operation Mincemeat": 0,
     "Paddington The Musical": -0.12,
     "Pretty Woman The Musical": 0,
     "Pride": 0,
     "RENT": 0,
     "Romeo & Juliet": 0.025,
     "Rosencrantz and Guildenstern Are Dead": 0,
     "SIX the Musical": 0.018,
     "Sinatra the Musical": 0,
     "Stranger Things: The First Shadow": 0.056,
     "The Book of Mormon": 0,
     "The Cherry Orchard": 0,
     "The Devil Wears Prada": 0.035,
     "The Hunger Games: On Stage": 0.028,
     "The Jungle Book": 0.075,
     "The Lion King": 0.077,
     "The Lives of Others": 0,
     "The Mousetrap": -0.072,
     "The Phantom of the Opera": -0.037,
     "The Play That Goes Wrong": 0.01,
     "The Standard of Living": 0,
     "Titanique": 0,
     "Wicked": 0.052
    }
   };